// Pad a number to 2 digits
const pad = (num: number) => `${Math.floor(Math.abs(num))}`.padStart(2, '0');
// Get timezone offset in ISO format (+hh:mm or -hh:mm)
const getTimezoneOffset = (date: Date) => {
  const tzOffset = -date.getTimezoneOffset();
  const diff = tzOffset >= 0 ? '+' : '-';
  return diff + pad(tzOffset / 60) + ':' + pad(tzOffset % 60);
};

export const toISOStringWithTimezone = (date: Date) => {
  return (
    date.getFullYear() +
    '-' +
    pad(date.getMonth() + 1) +
    '-' +
    pad(date.getDate()) +
    'T' +
    pad(date.getHours()) +
    ':' +
    pad(date.getMinutes()) +
    ':' +
    pad(date.getSeconds()) +
    getTimezoneOffset(date)
  );
};

export const timestampToISOStringWithTimezone = (timestamp: number, tz?: string) => {
  const timeZone = tz ?? Intl.DateTimeFormat().resolvedOptions().timeZone;
  const date = new Date(new Date(timestamp).toLocaleString('en-US', { timeZone }));
  return toISOStringWithTimezone(date);
};
